var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.options.data)?_c('ag-grid-vue',{staticClass:"ag-theme-alpine",staticStyle:{"width":"100%","height":"400px"},attrs:{"options":_vm.options}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }